export function objectIdString(id) {
  if (typeof id === 'string') {
    return id;
  } else if (typeof id === 'object' && typeof id.toHexString === 'function') {
    return id.toHexString();
  } else if (id) {
    return id.toString();
  }
  return id;
}



// WEBPACK FOOTER //
// ./src/utils/ObjectIds.js